export const testimonialData = [
  {
    name: 'Evert R',
    testimonial: `"A great product with a friendly and helpful team. Control D is always evolving and on top of latest trends in the cyber-sec space. It provided filtering and web protection capabilities to our customers, especially those on a tight budget."`,
  },
  {
    name: 'Jake P',
    testimonial: `"Control D has been easy to setup and deploy across our customers. Not only is it a great product, but the people behind it are passionate about security and privacy. Looking forward to see how the product develops in the future."`,
  },
  {
    name: 'Alex S',
    testimonial: `"Control D is a very highly customizable DNS platform, that is not overly complicated. Works on mobile without any software and the redirection feature is quite excellent as it eliminated the need for VPNs for our company."`,
  },
  {
    name: 'Niel F',
    testimonial: `"The best part of ControlD isn’t the system itself, which does exactly what it claims to and does it incredibly well. The best part though is the support and the team providing it. I have rarely worked with a technology partner who was so responsive and adaptable to our complex and evolving technology environment."`,
  },
  {
    name: 'James S',
    testimonial: `"I'd been using @NextDNS Pro for years, but have recently migrated to @ControlDNS. While I had no issues with NextDNS, I've found Control D to provide features NextDNS doesn't offer. I've especially come to like their service redirection feature."`,
  },
  {
    name: 'Evert R',
    testimonial: `"A great product with a friendly and helpful team. Control D is always evolving and on top of latest trends in the cyber-sec space. It provided filtering and web protection capabilities to our customers, especially those on a tight budget."`,
  },
  {
    name: 'Jake P',
    testimonial: `"Control D has been easy to setup and deploy across our customers. Not only is it a great product, but the people behind it are passionate about security and privacy. Looking forward to see how the product develops in the future."`,
  },
  {
    name: 'Alex S',
    testimonial: `"Control D is a very highly customizable DNS platform, that is not overly complicated. Works on mobile without any software and the redirection feature is quite excellent as it eliminated the need for VPNs for our company."`,
  },
  {
    name: 'Niel F',
    testimonial: `"The best part of ControlD isn’t the system itself, which does exactly what it claims to and does it incredibly well. The best part though is the support and the team providing it. I have rarely worked with a technology partner who was so responsive and adaptable to our complex and evolving technology environment."`,
  },
  {
    name: 'James S',
    testimonial: `"I'd been using @NextDNS Pro for years, but have recently migrated to @ControlDNS. While I had no issues with NextDNS, I've found Control D to provide features NextDNS doesn't offer. I've especially come to like their service redirection feature."`,
  },
  {
    name: 'Evert R',
    testimonial: `"A great product with a friendly and helpful team. Control D is always evolving and on top of latest trends in the cyber-sec space. It provided filtering and web protection capabilities to our customers, especially those on a tight budget."`,
  },
  {
    name: 'Jake P',
    testimonial: `"Control D has been easy to setup and deploy across our customers. Not only is it a great product, but the people behind it are passionate about security and privacy. Looking forward to see how the product develops in the future."`,
  },
  {
    name: 'Alex S',
    testimonial: `"Control D is a very highly customizable DNS platform, that is not overly complicated. Works on mobile without any software and the redirection feature is quite excellent as it eliminated the need for VPNs for our company."`,
  },
  {
    name: 'Niel F',
    testimonial: `"The best part of ControlD isn’t the system itself, which does exactly what it claims to and does it incredibly well. The best part though is the support and the team providing it. I have rarely worked with a technology partner who was so responsive and adaptable to our complex and evolving technology environment."`,
  },
  {
    name: 'James S',
    testimonial: `"I'd been using @NextDNS Pro for years, but have recently migrated to @ControlDNS. While I had no issues with NextDNS, I've found Control D to provide features NextDNS doesn't offer. I've especially come to like their service redirection feature."`,
  },
  {
    name: 'Evert R',
    testimonial: `"A great product with a friendly and helpful team. Control D is always evolving and on top of latest trends in the cyber-sec space. It provided filtering and web protection capabilities to our customers, especially those on a tight budget."`,
  },
  {
    name: 'Jake P',
    testimonial: `"Control D has been easy to setup and deploy across our customers. Not only is it a great product, but the people behind it are passionate about security and privacy. Looking forward to see how the product develops in the future."`,
  },
  {
    name: 'Alex S',
    testimonial: `"Control D is a very highly customizable DNS platform, that is not overly complicated. Works on mobile without any software and the redirection feature is quite excellent as it eliminated the need for VPNs for our company."`,
  },
  {
    name: 'Niel F',
    testimonial: `"The best part of ControlD isn’t the system itself, which does exactly what it claims to and does it incredibly well. The best part though is the support and the team providing it. I have rarely worked with a technology partner who was so responsive and adaptable to our complex and evolving technology environment."`,
  },
  {
    name: 'James S',
    testimonial: `"I'd been using @NextDNS Pro for years, but have recently migrated to @ControlDNS. While I had no issues with NextDNS, I've found Control D to provide features NextDNS doesn't offer. I've especially come to like their service redirection feature."`,
  },
  {
    name: 'Evert R',
    testimonial: `"A great product with a friendly and helpful team. Control D is always evolving and on top of latest trends in the cyber-sec space. It provided filtering and web protection capabilities to our customers, especially those on a tight budget."`,
  },
  {
    name: 'Jake P',
    testimonial: `"Control D has been easy to setup and deploy across our customers. Not only is it a great product, but the people behind it are passionate about security and privacy. Looking forward to see how the product develops in the future."`,
  },
  {
    name: 'Alex S',
    testimonial: `"Control D is a very highly customizable DNS platform, that is not overly complicated. Works on mobile without any software and the redirection feature is quite excellent as it eliminated the need for VPNs for our company."`,
  },
  {
    name: 'Niel F',
    testimonial: `"The best part of ControlD isn’t the system itself, which does exactly what it claims to and does it incredibly well. The best part though is the support and the team providing it. I have rarely worked with a technology partner who was so responsive and adaptable to our complex and evolving technology environment."`,
  },
  {
    name: 'James S',
    testimonial: `"I'd been using @NextDNS Pro for years, but have recently migrated to @ControlDNS. While I had no issues with NextDNS, I've found Control D to provide features NextDNS doesn't offer. I've especially come to like their service redirection feature."`,
  },
  {
    name: 'Evert R',
    testimonial: `"A great product with a friendly and helpful team. Control D is always evolving and on top of latest trends in the cyber-sec space. It provided filtering and web protection capabilities to our customers, especially those on a tight budget."`,
  },
  {
    name: 'Jake P',
    testimonial: `"Control D has been easy to setup and deploy across our customers. Not only is it a great product, but the people behind it are passionate about security and privacy. Looking forward to see how the product develops in the future."`,
  },
  {
    name: 'Alex S',
    testimonial: `"Control D is a very highly customizable DNS platform, that is not overly complicated. Works on mobile without any software and the redirection feature is quite excellent as it eliminated the need for VPNs for our company."`,
  },
  {
    name: 'Niel F',
    testimonial: `"The best part of ControlD isn’t the system itself, which does exactly what it claims to and does it incredibly well. The best part though is the support and the team providing it. I have rarely worked with a technology partner who was so responsive and adaptable to our complex and evolving technology environment."`,
  },
  {
    name: 'James S',
    testimonial: `"I'd been using @NextDNS Pro for years, but have recently migrated to @ControlDNS. While I had no issues with NextDNS, I've found Control D to provide features NextDNS doesn't offer. I've especially come to like their service redirection feature."`,
  },
  {
    name: 'Evert R',
    testimonial: `"A great product with a friendly and helpful team. Control D is always evolving and on top of latest trends in the cyber-sec space. It provided filtering and web protection capabilities to our customers, especially those on a tight budget."`,
  },
  {
    name: 'Jake P',
    testimonial: `"Control D has been easy to setup and deploy across our customers. Not only is it a great product, but the people behind it are passionate about security and privacy. Looking forward to see how the product develops in the future."`,
  },
  {
    name: 'Alex S',
    testimonial: `"Control D is a very highly customizable DNS platform, that is not overly complicated. Works on mobile without any software and the redirection feature is quite excellent as it eliminated the need for VPNs for our company."`,
  },
  {
    name: 'Niel F',
    testimonial: `"The best part of ControlD isn’t the system itself, which does exactly what it claims to and does it incredibly well. The best part though is the support and the team providing it. I have rarely worked with a technology partner who was so responsive and adaptable to our complex and evolving technology environment."`,
  },
  {
    name: 'James S',
    testimonial: `"I'd been using @NextDNS Pro for years, but have recently migrated to @ControlDNS. While I had no issues with NextDNS, I've found Control D to provide features NextDNS doesn't offer. I've especially come to like their service redirection feature."`,
  },
]
